<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false">

    <h1>{{ $t('skirental.wishes.pick') }}</h1>

    <div v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'storstenshojden'">

      <div v-if="params.person.products[0].code.match(/MULTI/)">
        <h5 class="multi">{{ $t('skirental.wishes.multi-title') }}</h5>
        <div class="flex">
          <SwitchButton @toggle="toggle" store="startSki" :iconscale="2" :value="wishes.startSki" :sync="true" :labels="{ checked: $t('skirental.wishes.options.skis'), unchecked: $t('skirental.wishes.options.skis')}" />
          <SwitchButton @toggle="toggle" store="startSnowboard" :iconscale="2" :value="wishes.startSnowboard" :sync="true" :labels="{ checked: $t('skirental.wishes.options.snowboard'), unchecked: $t('skirental.wishes.options.snowboard')}" />
          <div style="clear:both;"></div>
        </div>
        <div style="clear:both;"></div>
      </div>

      <h5>{{ $t('skirental.wishes.shoes') }}</h5>
      <div class="flex">
        <SwitchButton @toggle="toggle" store="wideCalf" :iconscale="2" :value="wishes.wideCalf" :sync="true" :labels="{ checked: $t('skirental.wishes.options.wideCalf'), unchecked: $t('skirental.wishes.options.wideCalf')}" />
        <SwitchButton @toggle="toggle" store="wideFoot" :iconscale="2" :value="wishes.wideFoot" :sync="true" :labels="{ checked: $t('skirental.wishes.options.wideFoot'), unchecked: $t('skirental.wishes.options.wideFoot')}" />
        <SwitchButton @toggle="toggle" store="softShoes" :iconscale="2" :value="wishes.softShoes" :sync="true" :labels="{ checked: $t('skirental.wishes.options.softShoes'), unchecked: $t('skirental.wishes.options.softShoes')}" />
        <SwitchButton @toggle="toggle" store="hardShoes" :iconscale="2" :value="wishes.hardShoes" :sync="true" :labels="{ checked: $t('skirental.wishes.options.hardShoes'), unchecked: $t('skirental.wishes.options.hardShoes')}" />
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>

      <div v-if="hasSkis">
        <h5>{{ $t('skirental.wishes.skis') }}</h5>
        <div class="flex">
          <SwitchButton @toggle="toggle" store="shortTurn" :iconscale="2" :value="wishes.shortTurn" :sync="true" :labels="{ checked: $t('skirental.wishes.options.shortTurn'), unchecked: $t('skirental.wishes.options.shortTurn')}" />
          <SwitchButton @toggle="toggle" store="longTurn" :iconscale="2" :value="wishes.longTurn" :sync="true" :labels="{ checked: $t('skirental.wishes.options.longTurn'), unchecked: $t('skirental.wishes.options.longTurn')}" />
          <div style="clear:both;"></div>
        </div>
        <div style="clear:both;"></div>
      </div>

      <div v-if="hasSnowboard">
        <h5>{{ $t('skirental.wishes.snowboard') }}</h5>
        <p>{{ $t('skirental.wishes.foot-in-front', {name: params.person.name}) }}</p>
        <div class="flex">
          <SwitchButton @toggle="toggle" store="preferedFootLeft" :iconscale="2" :value="wishes.preferedFootLeft" :sync="true" :labels="{ checked: $t('skirental.wishes.options.preferedFootLeft'), unchecked: $t('skirental.wishes.options.preferedFootLeft')}" />
          <SwitchButton @toggle="toggle" store="preferedFootRight" :iconscale="2" :value="wishes.preferedFootRight" :sync="true" :labels="{ checked: $t('skirental.wishes.options.preferedFootRight'), unchecked: $t('skirental.wishes.options.preferedFootRight')}" />
          <div style="clear:both;"></div>
        </div>
        <div style="clear:both;"></div>
      </div>

    </div>

    <div>
      <h5 class="multi" v-if="SITE_CONFIG.site === 'branas'">{{ $t('skirental.wishes.other') }}</h5>
      <div class="flex">
        <div class="full">
          <p>{{ $t('skirental.wishes.other-help') }}</p>
          <textarea rows="2" class="text-input" v-model="wishes.freeText" />
        </div>
      </div>
      <div style="clear:both;"></div>
    </div>

    <div class="center">
      <button class="small" @click="clicked">{{ $t('skirental.wishes.save') }}</button>
    </div>

  </Modal>
</template>

<script>
import Modal from '@/components/components/Modal';
import SwitchButton from '@/components/components/SwitchButton';
import { mapMutations, mapGetters } from 'vuex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    SwitchButton,
  },
  data() {
    return {
      wishes: {},
    };
  },
  beforeMount() {
    /* eslint-disable */
    for (let i in this.params.wishes) {
      this.wishes[i] = this.params.wishes[i];
    }
  },
  computed: {
    ...mapGetters([
      'confirmedAccomodations',
    ]),
    hasSnowboard() {
      let codes = [];
      this.params.person.products.forEach((product) => {
        product.categories.forEach((category) => {
          codes.push(category.slug);
        });
      });

      return codes.indexOf('snowboard') !== -1;
    },
    hasSkis() {
      let codes = [];
      this.params.person.products.forEach((product) => {
        product.categories.forEach((category) => {
          codes.push(category.slug);
        });
      });

      if (codes.indexOf('alpine') !== -1) {
        return true;
      }

      if (codes.indexOf('telemark') !== -1) {
        return true;
      }

      return codes.indexOf('snowblades') !== -1;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'addRentalPeople',
    ]),
    toggle(payload) {
      this.wishes[payload.key] = payload.value;
      this.wishes.hasWishes = false;
      for (let i in this.wishes) {
        if (this.wishes[i]) {
          this.wishes.hasWishes = true;
        }
      }
    },
    clicked() {
      this.params.click(this.wishes);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.flex
  display flex
  flex-wrap wrap
  justify-content space-between
  max-width 380px
  div
    width 170px
    margin-right 20px
    text-align left
    margin-bottom 10px
    float left
    button
      width 90%
    &.full
      width 360px
      max-width: 100%
      textarea
        width 100%

.text-input
  input-border()
  font-size: 1.2em

h5
  united-heavy()
  font-size 14px
  font-weight 900
  letter-spacing 0.4px
  color #1c1c1c
  text-transform: uppercase;
  position relative
  &:after
    border-bottom solid 1px #d2e4ea
    top 10px
    left 55px
    position absolute
    width calc(100% - 55px - 20px)
    content ""
  &.multi
    &:after
      left 150px
      width calc(100% - 150px - 20px)
</style>



// WEBPACK FOOTER //
// SkiRentalWishes.vue?502065c9